import React from 'react';
import { Coffee } from 'lucide-react';
import { CONSTANTS } from '../../data';

interface BrewButtonProps {
  stationIndex: number;
  onBrew: () => void;
  disabled: boolean;
  touchFeedback: boolean;
  containerWidth: number;
  containerPadding: number;
  elementGap: number;
}

const BrewButton: React.FC<BrewButtonProps> = ({ 
  stationIndex, 
  onBrew, 
  disabled, 
  touchFeedback, 
  containerWidth,
  containerPadding,
  elementGap
}) => {
  // Check if we're on mobile
  const isMobile = window.innerWidth < CONSTANTS.MOBILE_UI.MOBILE_BREAKPOINT;
  
  // Calculate responsive sizing based on container
  const buttonHeight = Math.max(
    isMobile ? CONSTANTS.BREW_STATION_GRID.MIN_MOBILE_BUTTON_HEIGHT : CONSTANTS.BREW_STATION_GRID.MIN_BUTTON_HEIGHT,
    containerWidth * CONSTANTS.BREW_STATION_GRID.BUTTON_HEIGHT_RATIO
  );
  const textSize = Math.max(
    CONSTANTS.BREW_STATION_GRID.MIN_TEXT_SIZE,
    containerWidth * CONSTANTS.BREW_STATION_GRID.TEXT_SIZE_RATIO
  );
  const iconSize = Math.max(
    CONSTANTS.BREW_STATION_GRID.MIN_ICON_SIZE,
    containerWidth * CONSTANTS.BREW_STATION_GRID.ICON_SIZE_RATIO
  );

  return (
    <button
      data-tutorial-id={`brew-button-${stationIndex}`}
      onClick={onBrew}
      disabled={disabled}
      className={`brew-button flex-1 bg-primary-action text-white font-bold rounded-lg disabled:bg-gray-300 disabled:cursor-not-allowed hover:bg-accent transition-all flex items-center justify-center active:scale-95 ${
        touchFeedback ? 'ring-2 ring-primary-action/50' : ''
      }`}
      style={{
        height: `${buttonHeight}px`,
        gap: `${Math.max(4, elementGap / 2)}px`,
        fontSize: `${textSize}px`,
        minHeight: `${buttonHeight}px`,
        touchAction: 'manipulation',
        padding: `0 ${Math.max(8, elementGap)}px`,
      }}
    >
      <Coffee size={iconSize} />
      {containerWidth < 200 ? 'BREW' : 'BREW!'}
    </button>
  );
};

export default BrewButton;
